module.exports = "<div class=\"{{ctrl.baseContainerClass}}\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n      <h1>{{ctrl.pageTitle}}</h1>\r\n\r\n      <uib-accordion close-others=\"true\">\r\n        <div uib-accordion-group class=\"bs-callout bs-callout-info\" heading=\"{{faq.question}}\" ng-repeat=\"faq in ctrl.data\">\r\n          <div ng-bind-html=\"faq.answer\"></div>\r\n        </div>\r\n      </uib-accordion>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/directories/faq/list/faq-directory.html
// module id = 267
// module chunks = 0